document.addEventListener('DOMContentLoaded', () => {

  const button = document.querySelector('.bundle-add-button');

  if (!button) return;

  button.addEventListener('click', async () => {

    const mainVariant = button.dataset.mainVariant;
    const giftVariant = button.dataset.giftVariant;

    button.disabled = true;
    button.innerText = 'Ajout...';

    try {

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: mainVariant,
              quantity: 1
            },
            {
              id: giftVariant,
              quantity: 1,
              properties: {
                '_freeGift': 'true'
              }
            }
          ]
        })
      });
       
   
      document.dispatchEvent(
        new CustomEvent('cart:refresh')
      );
      
    window.location.href = '/cart';
     

    } catch (error) {

      console.error(error);

      alert('Erreur bundle');

    }

    button.disabled = false;
    button.innerText = 'Ajouter au Panier';

  });

});